export type QuoteAccessoryCategoryType =
  | 'Essential Components'
  | 'Optional Enhancements';

const ESSENTIAL_ACCESSORY_TYPES: ReadonlySet<string> = new Set([
  'line_set',
  'drain_hose',
  'wire',
  'heat_kit',
  'txv',
  'conversion_txv',
  'lp_conversion_kit',
  'communicating',
  'rds_board',
  'rds_sensor',
  'rds_board_and_sensor'
]);

export const isEssentialAccessoryType = (type: string): boolean =>
  ESSENTIAL_ACCESSORY_TYPES.has(type);

export const quoteAccessoryCategory = (
  type: string
): QuoteAccessoryCategoryType =>
  isEssentialAccessoryType(type)
    ? 'Essential Components'
    : 'Optional Enhancements';
